<template>
	<apexchart
		:width="width"
    :height="height"
		:options="chartOptions"
		:series="parsedData"
	/>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "QueueTotals",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    width: {
      type: [Number, String],
      default: "100%",
    },
    height: {
      type: [Number, String],
      default: "100%",
    },
    value: {
      type: Number,
      default: 75,
    },
    data: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  data() {
    return {
      categories: [],
    };
  },
  computed: {
    parsedData() {
      const dataArray = [
        {name: "Pedidos", data: []},
        {name: "Elogios", data: []},
        {name: "Reclamações", data: []},
        {name: "Outros", data: []},
        {name: "Técnicas", data: []},
      ];

      if(this.data && typeof this.data === 'object'){
        const keys = Object.keys(this.data);
        this.categories = keys;

        keys.forEach(cat => {
          const canais = this.data[cat] || {};
          dataArray[0].data.push(canais['Pedidos'] ?? 0);
          dataArray[1].data.push(canais['Elogios'] ?? 0);
          dataArray[2].data.push(canais['Reclamações'] ?? 0);
          dataArray[3].data.push(canais['Outros'] ?? 0);
          dataArray[4].data.push(canais['Técnicas'] ?? 0);
        });

      } else {
        this.categories = [];
      }

      return dataArray;
    },
    
    chartOptions() {
      return {
        title: {
          text: "Solicitações",
          align: "center",
          style: {
            fontSize: "14px",
            fontWeight: "bold",
          },
        },
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: true
          },
          stackOnlyBar: true
        },
        colors: ["#1C869A", "#1F942B",  '#8B0000', '#DAA520', '#6A5ACD'],
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 5,
                style: {
                  fontSize: '12px',
                  fontWeight: 600,
                  color: '#373d3f',
                  backgroundColor: '#1c869a'
                }
              }
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#fff"],
            fontSize: "11px",
            fontWeight: "bold",
          },
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 1,
            opacity: 0.9,
            color: "black",
          },
        },
        xaxis: {
          categories: (!this.data || typeof this.data !== 'object' || Array.isArray(this.data) || !Object.keys(this.data).length)
            ? []
            : Object.keys(this.data),
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: {
            show: false,
          },
        },
        yaxis: {
          show: true,
        },
        grid: {
          show: true,
          padding: {
            right: 60
          }
        },
        tooltip: {
          enabled: true,
        },
        legend: {
          show: true,
          position: "top",
        },
      };
    },
  },
};
</script>

<style scoped>
.example {
  padding: 0 10px;
}
</style>